
<!--
================================================================================================================
================================================================================================================
================================================================================================================
-->

<template>

<div class="main-wrapper" ref="root">
  <div class="mainPanel">
    <div class="mainPanelCenterContent">

      <div class="contentlogo">
        <span><img src="../assets/logo.png" alt class="content-logo" /></span>
      </div>


      <div class="detail_header_class">
        FMN OTA Tools
      </div>

      <!--
            <label class="text-reader">
              <input type="file" @change="loadTextFromFile">
         /label>
              <textarea rows="10" v-model="text"></textarea>
              <br>
              <text-reader @load="text = $event"></text-reader>
            -->


      <!-- ----- FMN Model ----- -->
      <div class="option_class">
        <div class="optionbox">
          <select v-model="option_fmn_model" class="selectstyle"  @change="selectFMNModelChange">
            <option disabled value="">Please select FMN model</option>
            <option>ESkateboard</option>
            <option>SH100</option>
            <option>OLA</option>
            <option>ViviTag</option>
            <option>SkytagIII</option>
            <option>Locator</option>
            <option>FMCA</option>
          </select>
        </div>
      </div>


      <div class="slider_class" v-if="system_debug_mode===true">
        <div class="slider_class_text_green" >
          Just OTA
        </div>
        <label class="switch">
          <input type="checkbox" @change="toggleCheckbox" v-model="Option_ResetAll">
          <span class="slider round"></span>
        </label>
        <div class="slider_class_text_red">
          Reset All
        </div>
      </div>




      <!-- ----- BLE Scan Command ----- -->
      <button
          class="ble_scan_button"
          @click="DiscoverDevice"
      >Connect Device
      </button>


      <!-- ----- OTA Command ----- -->
      <button v-if="sysConnected==true && system_ota_state==0"
          class="ota_button"
          @click="OTADevice"
      >Start Upgrade
      </button>


      <div class="one-fourth" v-if="sysConnected==true && system_ota_state>0">
        <circular-percentage size="60" :done=done :missing=missing />
      </div>

      <!--
      <div class="one-fourth">
          <circular-percentage :size="size" :done="3" :missing="1" arcColor="#0000ff" bgCircleColor="#0000bb33" />
      </div>
      <div class="one-fourth">
        <circular-percentage size="80" :done="60" :missing="30" arcColor="#ff0000" bgCircleColor="#ff000033" />
      </div>
      <div class="one-fourth">
        <circular-percentage size="60" :done=done :missing=missing />
      </div>
      <div class="one-fourth">
          <circular-percentage size="40" :done="90" :missing="10" arcColor="#fff000" bgCircleColor="#fff00033" />
      </div>

      <ProgressBar size="medium" val="60" text="60"></ProgressBar>

      <progress-bar size="large" style="width: 95%" text-position="inside" :val="increasing_pct_Vertex" :text="increasing_pct_Vertex == 100 ? completedVert : increasing_pct_Vertex+ '%' "
                    :bar-color="increasing_pct_Vertex == 100 ? vertColors : normalColors " :text-fg-color="increasing_pct_Vertex == 100? finishText : normalText" />
      -->


      <div class="textarea" contenteditable="false" id="text" v-if="system_debug_mode===true">
      </div>



    </div>
  </div>
</div>
<!--
  <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/>
-->
</template>






<!--
================================================================================================================
================================================================================================================
================================================================================================================
-->

<script>
import axios from "axios"
import CircularPercentage from '../components/CircularPercentage.vue'
import querystring from "querystring"
import {version} from "vue";
//import FileReader from "./FileReader";
//import Vue from 'vue'
//import ProgressBar from 'vue-simple-progress'
//import KProgress from 'k-progress';

/*
new Vue({
  components: {
    ProgressBar
  }
})
*/
export default {
  name: 'App',
  components: {
    CircularPercentage
//    FileReader
    //ProgressBar,
    //HelloWorld
  },


  // ********************************************************************************************
  // ***************************                  Data           ********************************
  // ********************************************************************************************
  data() {
    return {
        model_text:"FMN Model:",

        option_fmn_model:"",
        Option_ResetAll:false,

        system_debug_mode:false,

        sysDevice: null,
        sysService: null,
        sysCharacteristic: null,
        sysReadCharacteristic: null,
        sysWriteCharacteristic: null,
        sysServer: null,

        devicename:null,

        ota_filedata:"",
        token_filedata:"",
        tokenlist_filedata:"",

        Connected_Device: null,
        Connected_Server: null,
        sysConnected: false,

        WIFISETTING_SERVICE : "6455e670-a146-11e2-9e96-0800200c9afe",

        OTA_SERVICE:              "5265616c-6d65-6761-2d49-6e73696465aa",
        OTA_WRITE_CHARACTERISTIC: "5265616c-6d66-6761-2d49-6e73696465aa",
        OTA_READ_CHARACTERISTIC:  "5265616c-6d67-6761-2d49-6e73696465aa",

        TEST_SERVICE:         "00001523-1212-efde-1523-785feabcd123",
        READ_CHARACTERISTIC: "00001524-1212-efde-1523-785feabcd123",
        WRITE_CHARACTERISTIC:  "00001525-1212-efde-1523-785feabcd123",

        GENERIC_ACCESS_SERVICE : "00001800-0000-1000-8000-00805f9b34fb",
        GENERIC_ATTRIBUTE_SERVICE : "00001801-0000-1000-8000-00805f9b34fb",
        DEVICE_INFORMATION_SERVICE : "0000180a-0000-1000-8000-00805f9b34fb",
        BATTERY_SERVICE: '0000180f-0000-1000-8000-00805f9b34fb',

        system_ota_state: 0,

        ota_filename:"",

        STATE_OTA_NULL: 0,
        STATE_OTA_0:    1,    // Traditional OTA Service Set Signature
        STATE_OTA_1:    2,    // Traditional OTA Service Reboot command -> Ask for Reconnect
        STATE_OTA_BOOT: 3,    // OTA Boot Idle -> Command entry
        STATE_OTA_GET_FW:4,   // Get Firmware Version
        STATE_OTA_GET_NAME:5, // Get Device Name
        // If reset to default -> clear user & pair flash
        STATE_OTA_RESET_DEF:6,
        // Download Token Hex
        STATE_OTA_SET_TOKEN_ADD:7,
        STATE_OTA_SET_TOKEN_DATA:8,
        // Download Application Hex
        STATE_OTA_SET_APP_ADD:9,
        STATE_OTA_SET_APP_DATA:10,

        STATE_OTA_COMPLETE: 11,

        system_DOM_fail_count:0,

        OTA_BLOCK_SIZE: 128,
        //OTA_BLOCK_SIZE: 220,
        PAGE_POINTER_SIZE:10251,
        file_pointer:0,         // global file pointer
        file_block_checksum:0,  // checksum of current 4K block
        file_block_address:0,   // address of current 4K block
        file_block_count:0,     // counter of current block
        file_block_size:0,      // how many block for 4K page
        file_block_continue:0,  // any 4K page?
        file_add_cmd:"",
        file_data_cmd:[],
        file_data_word:[],
        file_word_count:0,
        file_word_normal:0,
        file_word_reverse:0,

        size:100,
        done:0,
        missing:100,


    };
  },

  // ********************************************************************************************
  // ***************************                  Computed       ********************************
  // ********************************************************************************************
  computed: {

  },


  // ********************************************************************************************
  // ***************************                  Created        ********************************
  // ********************************************************************************************
  created() {

  },




  // ********************************************************************************************
  // ***************************                  Mounted        ********************************
  // ********************************************************************************************
  mounted() {
       //this.creatQrCode();
    //console.log('Vue version', version);

  },


  // ********************************************************************************************
  // ***************************                  Method         ********************************
  // ********************************************************************************************
  methods: {

    add_log( log )
    {
      if (this.system_debug_mode==false)
        return;


      let obj = document.getElementById("text");
      var currentDate = new Date().toLocaleTimeString();

      //obj.innerHTML = log + "<br>" +obj.innerHTML;
      obj.innerHTML += currentDate + ":   " + log;
      obj.innerHTML += "<br>";
      obj.scrollTop = obj.scrollHeight;
      //obj.scrollTop = obj.clientHeight;
      //obj.scrollTo(0,obj.scrollHeight);
    },

    loadTextFromFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();

      //reader.onload = e => this.$emit("load", e.target.result);
      reader.readAsText(file);
      reader.onload = (e) => {
        console.log("File Loaded " + e.target.result)
        this.add_log(e.target.result)
      }
    },







    async DiscoverDevice()
    {
      if ('bluetooth' in navigator) {
        console.log("Bluetooth Navigator OK");
        this.add_log("Start Scan .....");
      }
      else
      {
        console.log("Web Bluetooth Not Supported")
        this.add_log("Web Bluetooth Not Supported")
        alert("Web Bluetooth Not Supported")
      }


/* */
      //过滤出我们需要的蓝牙设备
      //过滤器
      var options = {
        //filters: [{ namePrefix: 'Omnivision Device' }],
        filters: [{ namePrefix: 'ble_ota'},
                  { namePrefix: 'AdvOTA'},
                  { namePrefix: 'ESkateboard'},
                  { namePrefix: 'SkyTag II'},
                  { namePrefix: 'ViviTag'},
                  { namePrefix: 'SkyTag Coin'},
                  { namePrefix: 'Ola Tag'},
                  ],

        //acceptAllDevices: true,
        // optionalServices: [ GENERIC_ACCESS_SERVICE ],
        optionalServices: [ //this.BATTERY_SERVICE,
                            this.OTA_SERVICE,
                            //this.GENERIC_ACCESS_SERVICE, this.GENERIC_ATTRIBUTE_SERVICE,
                            //this.DEVICE_INFORMATION_SERVICE
                          ]
        //optionalServices: ['battery_service', this.WIFISETTING_SERVICE]
      };

      await navigator.bluetooth.requestDevice(options)
        .then(device =>
        {
            this.sysDevice = device;
            console.log('> Device Name: ' + device.name);
            console.log('> Device Id: ' + device.id);
            console.log('> Connect status: ' + device.gatt.connected);

            this.devicename = device.name;

            //连接到该设备
            this.Connected_Device = device;
            //ConnectDevice();
            return device.gatt.connect();
        })
        .then(server =>
        {
            this.sysServer = server;

            console.log('Connect status: ' + this.sysDevice.gatt.connected);
            console.log('====> Getting Service…');
            return server.getPrimaryServices();
        })
        .then(Services =>
        {
            this.sysService = Services;

            console.log('Service Length: ' + this.sysService.length);
            Services.forEach(service => {
              console.log('Service UUID: ' + service.uuid);
            });

            console.log('====> Getting Characteristic…');
            // Getting Battery Level Characteristic…
            //return service.getCharacteristic('battery_level');
            return Services[0].getCharacteristics();
        })

        .then(Characteristics =>
        {
            this.sysCharacteristic = Characteristics;
            console.log('Characteristics Length: ' + this.sysCharacteristic.length);
            Characteristics.forEach(characteristics => {
              console.log('Characteristics UUID: ' + characteristics.uuid);
            });


            if (Characteristics.length==2)
            {
              if (Characteristics[0].uuid==this.OTA_WRITE_CHARACTERISTIC)
              {
                this.sysWriteCharacteristic = Characteristics[0]

                console.log('Write Characteristic UUID:  ' + this.sysWriteCharacteristic.uuid);
              }

              if (Characteristics[1].uuid==this.OTA_READ_CHARACTERISTIC)
              {
                this.sysReadCharacteristic = Characteristics[1]
                this.sysReadCharacteristic.startNotifications();
                this.sysReadCharacteristic.addEventListener('characteristicvaluechanged', this.handleCharacteristicValueChanged);

                console.log('Read Characteristic UUID:  ' + this.sysReadCharacteristic.uuid);
              }

              this.add_log('Connected ' + this.devicename);
              this.sysConnected = true;
              this.system_ota_state=this.STATE_OTA_NULL
              alert("Device " + this.devicename + " Connected");
            }

        })
        .then(value =>
        {
            console.log(`Value is :` + value);
        })
        .catch(error => {
            this.add_log("=> Exception: " + error);
        });




    },


    // -----------------------------------------
    // ----------     BLE Data Rx     ----------
    // -----------------------------------------
    handleCharacteristicValueChanged(event)
    {
      //let value = event.target.value.getUint8(0);
      let value = event.target.value;
      let a = [];
      let ota_reply_flag = false;

      //this.add_log('----- Handler Received -----');
      for (let i = 0; i < value.byteLength; i++) {
        //a.push('0x' + ('00' + value.getUint8(i).toString(16)).slice(-2));
        a.push(value.getUint8(i));
      }
      this.add_log('      Received: ' + a.join(' '));

      /*
      OTA_ERR_SUCCESS         	= 0,
      OTA_ERR_INVALID_CMD         = 1,
      OTA_ERR_UNEXPECTED_PACKET   = 2,
      OTA_ERR_FCS_FAILED          = 3,
      OTA_ERR_ILLEGAL_ADDRESS     = 4,
      OTA_ERR_INVALID_CREDIT      = 5,
      OTA_REPLY_FW_VERSION       	= 6,
      OTA_REPLY_DEVICE_NAME      	= 7,
      */

      ota_reply_flag = false;
      if (this.system_ota_state==this.STATE_OTA_0)        // 1st stage
      {
        if (a[0]==0)
          ota_reply_flag = true;
      }
      else if (this.system_ota_state==this.STATE_OTA_1)   // not exist
      {
        if (a[0]==0)
          ota_reply_flag = true;
      }
      else if (this.system_ota_state==this.STATE_OTA_BOOT)    // 2nd Stage
      {
        if (a[0]==0)
          ota_reply_flag = true;
      }
      else if (this.system_ota_state==this.STATE_OTA_GET_FW)      // Reply FW Version
      {
        if (a[0]==6)
          ota_reply_flag = true;
      }
      else if (this.system_ota_state==this.STATE_OTA_GET_NAME)    // Reply Device Name
      {
        if (a[0]==7)
          ota_reply_flag = true;
      }
      else if (this.system_ota_state==this.STATE_OTA_RESET_DEF)
      {
        if (a[0]==0)
          ota_reply_flag = true;
      }
      // Todo: Handle Token Add
      // Todo: Handle Token Data

      else if (this.system_ota_state == this.STATE_OTA_SET_APP_ADD)
      {
        if (a[0]==0)
          ota_reply_flag = true;
      }
      else if (this.system_ota_state == this.STATE_OTA_SET_APP_DATA)
      {
        if (a[0]==0)
          ota_reply_flag = true;
      }
      else if (this.system_ota_state == this.STATE_OTA_COMPLETE)
      {
        // suppose Not here, must be some error returned
      }


      this.OTAReplyProcess(ota_reply_flag);

    },

    // ========================================================================================
    // ========================================================================================
    // ========================================================================================
    // ========================================================================================

    selectFMNModelChange()
    {
      /*
      <option>ESkateboard</option>
      <option>SH100</option>
      <option>OLA</option>
      <option>ViviTag</option>
      <option>SkytagIII</option>
      <option>Locator</option>
      */

      if (this.option_fmn_model == "ESkateboard")
        this.ota_filename = "./ESkate/ESkate_ota.hex"
      else if (this.option_fmn_model == "SH100")
        this.ota_filename = "./SH100/SH100_ota.hex"
      else if (this.option_fmn_model == "OLA")
        this.ota_filename = "./OLA/OLA_ota.hex"
      else if (this.option_fmn_model == "ViviTag")
        this.ota_filename = "./ViviTag/ViviTag_ota.hex"
      else if (this.option_fmn_model == "SkytagIII")
        this.ota_filename = "./SkytagIII/SkytagIII_ota.hex"
      else if (this.option_fmn_model == "Locator")
        this.ota_filename = "./Locator/Locator_ota.hex"
      else if (this.option_fmn_model == "FMCA")
        this.ota_filename = "./FMCA/FMCA_ota.hex"



      //console.log("Model " + this.option_fmn_model);
      //this.add_log("Model " + this.option_fmn_model);
      /*
      var a = new Uint8Array(20)
      a[0]= 0x02;                   // LED1 command

      if (this.option_fmn_model == 'Off')
        a[1]= 0x00;
      else if (this.option_fmn_model == 'Red')
        a[1]= 0x01;
      else if (this.option_fmn_model == 'Green')
        a[1]= 0x02;
      else if (this.option_fmn_model == 'Blue')
        a[1]= 0x03;

      console.log(a);
      this.sysWriteCharacteristic.writeValue(a);
      */
    },

    toggleCheckbox()
    {
      //this.done+=5;
      //this.missing-=5;
      //this.downloadAppFile();

      //this.add_log("Hex Data: " + this.ota_filedata)

      //this.downloadFile();
      //this.uploadFile();
      //alert("hello")
      //console.log("OTA Option " + this.Option_ResetAll);
      //this.add_log("Model " + this.Option_ResetAll);
    },

    // -----------------------------------------
    // ----------     OTA Button      ----------
    // -----------------------------------------
    OTADevice()
    {
      if (this.option_fmn_model == "")
      {
        alert("Please select FMN model.")
        return;
      }

      if ((this.devicename == "ble_ota") || (this.devicename == "AdvOTA"))
      {
        this.add_log("OTA Boot Directly");
        this.system_ota_state = this.STATE_OTA_BOOT   // Goto OTA Boot Directly
      }
      else
      {
        this.add_log("Traditional OTA Service");
        this.system_ota_state = this.STATE_OTA_0      // start from tradition OTA service
      }

      this.system_DOM_fail_count=0;
      this.OTATriggerProcess()

      var currentDate = new Date().toLocaleTimeString();
      console.log("OTA Start " + currentDate)
    },




    OTATriggerProcess()
    {
      let ota_cmd;

      if (this.system_ota_state == this.STATE_OTA_BOOT)
      {
        ota_cmd = new Uint8Array([0x01, 0x01, 0x043, 0x49, 0x4d, 0x52])
        this.ble_write(ota_cmd)
        this.add_log("OTA Boot Entry Send: " + ota_cmd);
      }
      else if (this.system_ota_state == this.STATE_OTA_GET_FW)
      {
        ota_cmd = new Uint8Array([0x01, 0x08, 0x08, 0x08])
        this.ble_write(ota_cmd)
        this.add_log("OTA Boot Get FW Version: " + ota_cmd);
      }
      else if (this.system_ota_state == this.STATE_OTA_GET_NAME)
      {
        ota_cmd = new Uint8Array([0x01, 0x09, 0x09, 0x09])
        this.ble_write(ota_cmd)
        this.add_log("OTA Boot Get Device Name: " + ota_cmd);
      }
      else if (this.system_ota_state == this.STATE_OTA_RESET_DEF)
      {
        ota_cmd = new Uint8Array([0x01, 0xAA, 0xAA, 0xAA])
        this.ble_write(ota_cmd)
        this.add_log("OTA Boot Reset Default: " + ota_cmd);
      }
      // Todo: Handle Token Add
      // Todo: Handle Token Data

      else if (this.system_ota_state == this.STATE_OTA_SET_APP_ADD)
      {
        if (this.file_pointer==0)
          this.downloadAppFile();       // async download file, only first time
        else
          this.getNextAppFileData()
      }
      else if (this.system_ota_state == this.STATE_OTA_SET_APP_DATA)
      {
        this.ble_write(this.file_data_cmd[this.file_block_count]);
        //console.log("Block Count: " + this.file_block_count)
        this.add_log("OTA Boot App Data: " + this.file_data_cmd[this.file_block_count]);
      }
      else if (this.system_ota_state == this.STATE_OTA_COMPLETE)
      {
        ota_cmd = new Uint8Array([0x01, 0x03])
        this.ble_write(ota_cmd)

        this.sysConnected = false;
        this.system_ota_state=this.STATE_OTA_NULL

        this.add_log("OTA Boot Complete: " + ota_cmd);
        console.log("DOM Fail Statistic: " + this.system_DOM_fail_count)
        var currentDate = new Date().toLocaleTimeString();
        console.log("OTA Finish " + currentDate)

        alert("OTA Completed")
      }

    },




    OTAReplyProcess(ota_reply_flag)
    {
      if (this.system_ota_state == this.STATE_OTA_BOOT)
      {
        this.file_pointer=0;    // start new app/token download

        if (ota_reply_flag==true)
          this.system_ota_state = this.STATE_OTA_GET_FW;
        else if (this.Option_ResetAll==true)
          this.system_ota_state = this.STATE_OTA_RESET_DEF;
        else
          this.system_ota_state = this.STATE_OTA_SET_APP_ADD;
      }
      else if (this.system_ota_state == this.STATE_OTA_GET_FW)
      {
        if (ota_reply_flag==true)
          this.system_ota_state = this.STATE_OTA_GET_NAME;
        else if (this.Option_ResetAll==true)
          this.system_ota_state = this.STATE_OTA_RESET_DEF;
        else
          this.system_ota_state = this.STATE_OTA_SET_APP_ADD;
      }
      else if (this.system_ota_state == this.STATE_OTA_GET_NAME)
      {
        if (this.Option_ResetAll==true)
          this.system_ota_state = this.STATE_OTA_RESET_DEF;
        else
          this.system_ota_state = this.STATE_OTA_SET_APP_ADD;
      }
      else if (this.system_ota_state == this.STATE_OTA_RESET_DEF)
      {
        if (this.Option_ResetAll==true)
          this.system_ota_state = this.STATE_OTA_SET_TOKEN_ADD;   // if Reset ok, then update token
        else
          this.system_ota_state = this.STATE_OTA_SET_APP_ADD; // goto update application code

      }
      // Todo: Handle Token Add
      // Todo: Handle Token Data

      else if (this.system_ota_state == this.STATE_OTA_SET_APP_ADD)
      {
        this.system_ota_state = this.STATE_OTA_SET_APP_DATA; // goto send application data
      }
      else if (this.system_ota_state == this.STATE_OTA_SET_APP_DATA)
      {
        if (ota_reply_flag!=true)
        {
          alert("OTA Fail. Pls retry")
          return
        }


        let total_page = this.ota_filedata.length/this.PAGE_POINTER_SIZE;
        let total_block = total_page * this.file_block_size

        let current_page = (this.file_pointer/this.PAGE_POINTER_SIZE)-1
        let current_block = (current_page * this.file_block_size) + this.file_block_count +1

        this.done = ((100*current_block)/total_block)
        if (this.done>100)
          this.done=100;
        this.missing = 100 - this.done



        this.file_block_count++;
        if (this.file_block_count<this.file_block_size)
          this.system_ota_state = this.STATE_OTA_SET_APP_DATA; // goto send application data
        else if (this.file_block_continue==true)
          this.system_ota_state = this.STATE_OTA_SET_APP_ADD;  // just finish 1 block, goto another block address
        else
        {
          this.system_ota_state = this.STATE_OTA_COMPLETE;      // all block finished
          this.done     = 100
          this.missing  = 0
        }

      }
      else if (this.system_ota_state == this.STATE_OTA_COMPLETE)
      {
        if (ota_reply_flag != true) {
          alert("OTA Fail. Pls retry")
          return
        }
      }

      this.OTATriggerProcess()
    },






    downloadAppFile ()
    {
      console.log("Open File: " + this.ota_filename)

      axios.get(this.ota_filename).then(this.getAppFileData)  // start in index.html directory
      /*
      axios({
        method: 'get',
        url: "./ESkate/ESkate_ota.hex"
      }).then(this.getFileData)  // start in index.html directory
      */
    },

    getAppFileData (res)
    {
      this.ota_filedata = res.data
      this.file_pointer=0;
      console.log("File Size: " + this.ota_filedata.length)

      this.getNextAppFileData()
    },

    getNextAppFileData ()
    {
      // ----- Prepare Addrsss Packet -----
      this.getaddress();    // seek @ and then locate address
      this.file_add_cmd = new Uint8Array(11)
      this.file_add_cmd[0] = 0x01
      this.file_add_cmd[1] = 0x04
      this.file_add_cmd[2] = this.file_data_word[0]
      this.file_add_cmd[3] = this.file_data_word[1]
      this.file_add_cmd[4] = this.file_data_word[2]
      this.file_add_cmd[5] = this.file_data_word[3]
      this.file_add_cmd[6] = 0x00
      this.file_add_cmd[7] = 0x10             // always 0x1000 per block
      this.file_add_cmd[8] = 0xFF     // dummy checksum
      this.file_add_cmd[9] = 0xFF     // dummy checksum
      this.file_add_cmd[10] = 0xFF    // dummy checksum

      // ----- Prepare 4K block data packet -----
      this.getdata()
      // todo: fill last 3 byte checksum


      this.file_block_count=0;        // reset count from 0
      if (this.ota_filedata[this.file_pointer+2]=='@')
        this.file_block_continue=true;  // means still have next block
      else
        this.file_block_continue=false; // means last block

      this.ble_write(this.file_add_cmd)
      this.add_log("OTA Boot App Address: " + this.file_add_cmd);
    },




    ble_write(value)
    {
      this.sysWriteCharacteristic.writeValue(value)
      .catch(() =>  {
        //console.log("DOMException: GATT operation already in progress.")
        this.system_DOM_fail_count++;
      //return Promise.resolve()
      //    .then(() => this.delayPromise(500))
      //    .then(() => { this.sysWriteCharacteristic.writeValue(value);});
      return Promise.resolve()
          .then(() => setTimeout(() => {
            this.sysWriteCharacteristic.writeValue(value);
          }, 200));
      });
    },



    // seek @ and then locate address
    getaddress()
    {
      for (; this.file_pointer<this.ota_filedata.length; this.file_pointer++)
      {
        if (this.ota_filedata[this.file_pointer] == '@')
        {
          this.file_pointer++
          this.getword();
          break;
        }
      }
      this.file_block_address = this.file_word_normal;
      console.log("Address: " + this.file_data_word)
      console.log("File Pointer: " + this.file_pointer);
    },

    getdata()
    {
      let i
      this.file_word_count=0;
      this.file_block_checksum =0;
      this.file_block_count=0;
      this.file_block_size=0;

      while(this.file_word_count<1024)
      {
        if ((1024-this.file_word_count)*4 >= this.OTA_BLOCK_SIZE)
          this.file_data_cmd[this.file_block_count] = new Uint8Array(this.OTA_BLOCK_SIZE)
        else
          this.file_data_cmd[this.file_block_count] = new Uint8Array((1024-this.file_word_count)*4)

        for (i=0;i<this.OTA_BLOCK_SIZE;)
        {
          this.file_pointer+=2 // skip line feed
          this.getword();
          this.file_block_checksum += this.file_word_normal
          //this.file_block_checksum &= 0x00FFFFFF
          this.file_word_count++;
          this.file_data_cmd[this.file_block_count][i++] = this.file_data_word[0];
          this.file_data_cmd[this.file_block_count][i++] = this.file_data_word[1];
          this.file_data_cmd[this.file_block_count][i++] = this.file_data_word[2];
          this.file_data_cmd[this.file_block_count][i++] = this.file_data_word[3];
        }
        //console.log("Data Block " + (this.file_block_count) + ": " + this.file_data_cmd[(this.file_block_count)]);
        //console.log("Data Block " + (this.file_block_count-1));
        this.file_block_size++
        this.file_block_count++;
      }

      //console.log("Checksum: " + this.file_block_checksum)
    },





    getword()
    {
      let temp_int;

      this.file_data_word = new Uint8Array(4)

      temp_int = (this.hex2int(this.ota_filedata[this.file_pointer++])<<4) + this.hex2int(this.ota_filedata[this.file_pointer++]);
      //console.log("Temp Int: " + temp_int)
      this.file_data_word[3] = temp_int
      //this.file_word_normal = temp_int;
      //this.file_word_reverse = temp_int;
      this.file_word_normal = 0;    // ignore MSB
      this.file_word_reverse = 0;

      temp_int = (this.hex2int(this.ota_filedata[this.file_pointer++])<<4) + this.hex2int(this.ota_filedata[this.file_pointer++]);
      //console.log("Temp Int: " + temp_int)
      this.file_data_word[2] = temp_int
      this.file_word_normal  = (this.file_word_normal<<8) + temp_int;
      this.file_word_reverse = this.file_word_reverse + (temp_int<<8);

      temp_int = (this.hex2int(this.ota_filedata[this.file_pointer++])<<4) + this.hex2int(this.ota_filedata[this.file_pointer++]);
      //console.log("Temp Int: " + temp_int)
      this.file_data_word[1] = temp_int
      this.file_word_normal  = (this.file_word_normal<<8) + temp_int;
      this.file_word_reverse = this.file_word_reverse + (temp_int<<16);

      temp_int = (this.hex2int(this.ota_filedata[this.file_pointer++])<<4) + this.hex2int(this.ota_filedata[this.file_pointer++]);
      //console.log("Temp Int: " + temp_int)
      this.file_data_word[0] = temp_int
      this.file_word_normal  = (this.file_word_normal<<8) + temp_int;
      this.file_word_reverse = this.file_word_reverse + (temp_int<<24);

      //console.log("Normal: " + this.file_word_normal)
      //console.log("Reverse: " + this.file_word_reverse)
      //console.log("Word: " + this.file_data_word)
    },

    hex2int(in_hex)
    {
      //let temp_int=0;
      return parseInt(in_hex, 16)
    },

    // arrange packet and prepare checksum
    getchecksum()
    {

    },


  },



}
</script>





<!--
================================================================================================================
================================================================================================================
================================================================================================================
-->


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}

.main-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
}


.mainPanel{
  display: flex;
  flex-direction: row;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 80%;
  height: 100%;
}

.mainPanelCenterContent{
  font-size:35px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 80%;
  height: 100%;
}

.contentlogo {
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  text-align: center;
}
.content-logo{
  width: 318px;
  height: 46px;
  margin-left: 00px;
  margin-top: 0px;
  margin-bottom: 5px;
}


.detail_header_class{
  font-size:30px;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 0px;
  color: #000000;
  text-align: center;
  padding:0px;
  border: 0;
}



.slider_class {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  margin-bottom: 10px;
}


.slider_class_text_green{
  font-size:26px;
  margin-top: 00px;
  margin-bottom: 00px;
  margin-left: 0px;
  color: green;
  text-align: center;
  padding:0px;
  border: 0;
}

.slider_class_text_red{
  font-size:26px;
  margin-top: 00px;
  margin-bottom: 00px;
  margin-left: 0px;
  color: red;
  text-align: center;
  padding:0px;
  border: 0;
}

.option_class {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  margin-bottom: 10px;
}


.option_text{
  font-size:18px;
  margin-top: 00px;
  margin-left: 0px;
  margin-right: 10px;
  height: 35px;
  font-weight: bold;
  color: #000000;
  text-align: left;
  padding:0px;
  border: 0;
  position: relative;
}


.optionbox{
  /*用div的样式代替select的样式*/
  margin-left: 10px;
  width: 300px;
  height: 40px;
  /*border-radius: 5px;*/
  /*盒子阴影修饰作用,自己随意*/
  /*box-shadow: 0 0 5px #ccc;*/
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: ridge;
  background-color: #ffffff;
  position: relative;
  font-size:18px;
  font-weight: bold;
  text-align: center;
  justify-content: center;
}


.selectstyle
{
  font-size:20px;
}


.ble_save_button
{
  border-radius:20px;
  font-size:20px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  align-items: flex-end;
  align-content: flex-end;
  margin-top: 10px;
  margin-right: 5%;
  width: 120px;
  height: 40px;
  background-color:#ec6620;
}


.bms_command_button
{
  border-radius:20px;
  font-size:18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  /* margin-left: auto; */
  padding:0px;
  border: 0;
  align-items: flex-end;
  align-content: flex-end;
  margin-top: 10px;
  margin-right: 5%;
  width: 100px;
  height: 30px;
  background-color:#ec6620;
}



.ble_scan_button
{
  border-radius:20px;
  font-size:18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  /* margin-left: auto; */
  padding:0px;
  border: 0;
  align-items: flex-end;
  align-content: flex-end;
  margin-top: 10px;
  margin-right: 0%;
  width: 150px;
  height: 40px;
  background-color: #ec6620;
}

.ota_button
{
  border-radius:20px;
  font-size:18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  /* margin-left: auto; */
  padding:0px;
  border: 0;
  align-items: flex-end;
  align-content: flex-end;
  margin-top: 30px;
  margin-bottom: 10px;
  margin-right: 0%;
  width: 150px;
  height: 40px;
  background-color: limegreen;
}

.one-fourth {
  width: 25%;
  float: left;
}

.textarea
{
  height: 150px;
  width: 80%;
  margin-top: 20px;
  font-size:15px;
  color: #ffffff;
  text-align: left;
  background-color:#2c3e50;
  overflow: auto;
}








.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 26px;
  margin-left: 10px;
  margin-right: 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: green;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 6px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: red;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}













.table_class {
  background-color: #ffffff;
  width: 80%;
  height: 90%;
  border: 2px solid #ccc;
  justify-content: left;
  margin-top: 0px;
  margin-left: 10px;
  margin-right: 0px;
  font-size: 15px;
}


tbody tr {
  display: table;
  width: 100%;
  height: 15px;
  table-layout: fixed;
  word-break: break-all;
  border-bottom: 1pt solid grey;
}




</style>


/*
this.file_data_cmd[0] = new Uint8Array([0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0x0, 0x0, 0x4, 0x0, 0x0, 0xf0, 0x3, 0x11, 0x0, 0x10, 0x0, 0x0, 0x0, 0x1, 0x21, 0x12, 0xc, 0x0, 0xc2, 0xa, 0x0, 0xf0, 0x2, 0xf8, 0x0, 0xf0, 0xbd, 0xf8, 0xc, 0xa0, 0x30, 0xc8, 0x8, 0x38, 0x24, 0x18, 0x2d, 0x18, 0xa2, 0x46, 0x67, 0x1e, 0xab, 0x46, 0x54, 0x46, 0x5d, 0x46, 0xac, 0x42, 0x1, 0xd1, 0x0, 0xf0, 0xaf, 0xf8, 0x7e, 0x46, 0xf, 0x3e, 0xf, 0xcc, 0xb6, 0x46, 0x1, 0x26, 0x33, 0x42, 0x0, 0xd0, 0xfb, 0x1a, 0xa2, 0x46, 0xab, 0x46, 0x33, 0x43, 0x18, 0x47, 0x4, 0xe, 0x2, 0x0, 0x44, 0xe, 0x2, 0x0, 0x10, 0x3a, 0x2, 0xd3, 0x78, 0xc8, 0x78, 0xc1, 0xfa, 0xd8, 0x52, 0x7, 0x1, 0xd3, 0x30, 0xc8, 0x30, 0xc1, 0x1, 0xd5, 0x4, 0x68, 0xc, 0x60, 0x70, 0x47, 0x0, 0x0]);
this.file_data_cmd[1] = new Uint8Array([0x0, 0x23, 0x0, 0x24, 0x0, 0x25, 0x0, 0x26, 0x10, 0x3a, 0x1, 0xd3, 0x78, 0xc1, 0xfb, 0xd8, 0x52, 0x7, 0x0, 0xd3, 0x30, 0xc1, 0x0, 0xd5, 0xb, 0x60, 0x70, 0x47, 0x10, 0xb5, 0x6e, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0x13, 0xfb, 0x10, 0xbd, 0x70, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0x63, 0xfc, 0x10, 0xbd, 0x66, 0x29, 0x2, 0xd1, 0x1c, 0xf0, 0xf9, 0xf8, 0x10, 0xbd, 0x65, 0x29, 0x2, 0xd1, 0x1c, 0xf0, 0xf4, 0xf8, 0x10, 0xbd, 0x67, 0x29, 0x2, 0xd1, 0x1c, 0xf0, 0xef, 0xf8, 0x10, 0xbd, 0x61, 0x29, 0x2, 0xd1, 0x1c, 0xf0, 0xf2, 0xf8, 0x10, 0xbd, 0x3, 0x68, 0x1b, 0xa, 0x1, 0xd3, 0x80, 0x23, 0x19, 0x43, 0x69, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0xba, 0xfa, 0x10, 0xbd, 0x64, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0xb5, 0xfa, 0x10, 0xbd, 0x75, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0xb0, 0xfa]);
this.file_data_cmd[2] = new Uint8Array([0x10, 0xbd, 0x6f, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0xe1, 0xfb, 0x10, 0xbd, 0x78, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0x1e, 0xfc, 0x10, 0xbd, 0xe9, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0x7d, 0xfb, 0x10, 0xbd, 0xe4, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0x78, 0xfb, 0x10, 0xbd, 0xf5, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0x73, 0xfb, 0x10, 0xbd, 0xef, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0xd4, 0xfb, 0x10, 0xbd, 0xf8, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0x13, 0xfc, 0x10, 0xbd, 0x3, 0x68, 0xdb, 0x9, 0x1, 0xd3, 0x80, 0x23, 0x19, 0x43, 0x63, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0xf5, 0xfa, 0x10, 0xbd, 0x73, 0x29, 0x2, 0xd1, 0x0, 0xf0, 0xf8, 0xfa, 0x10, 0xbd, 0xe3, 0x29, 0x2, 0xd1, 0x1, 0xf0, 0xe8, 0xf8, 0x10, 0xbd, 0xf3, 0x29, 0x2, 0xd1, 0x1, 0xf0, 0xeb, 0xf8, 0x10, 0xbd, 0x0, 0x20, 0x10, 0xbd, 0x1f, 0xb5]);
this.file_data_cmd[3] = new Uint8Array([0x0, 0xf0, 0xbc, 0xfc, 0x4, 0x0, 0x0, 0x20, 0x0, 0x21, 0x1c, 0xf0, 0x63, 0xf8, 0x40, 0x1c, 0x60, 0x60, 0x0, 0x20, 0x0, 0x21, 0x1c, 0xf0, 0x73, 0xf8, 0xe0, 0x60, 0x1f, 0xbd, 0x10, 0xb5, 0x10, 0xbd, 0x4, 0x48, 0x85, 0x46, 0xff, 0xf7, 0xea, 0xff, 0x14, 0xf0, 0x5b, 0xff, 0x1, 0xf0, 0x77, 0xfc, 0x0, 0x0, 0xe8, 0x6f, 0x0, 0x20, 0x3, 0xb4, 0xff, 0xf7, 0xf0, 0xff, 0x3, 0xbc, 0x0, 0xf0, 0x96, 0xfc, 0x2, 0x48, 0x80, 0x47, 0xef, 0xf3, 0x8, 0x80, 0x7, 0xf0, 0xd6, 0xff, 0x21, 0xa0, 0x0, 0x10, 0x10, 0xb5, 0x4, 0x46, 0x0, 0xf0, 0xf6, 0xf9, 0x0, 0x68, 0x0, 0x5d, 0x0, 0x7, 0x4, 0xd5, 0xdf, 0x2c, 0x2, 0xd0, 0x20, 0x46, 0x20, 0x38, 0x10, 0xbd, 0x20, 0x46, 0x10, 0xbd, 0x0, 0x0, 0x1c, 0xb5, 0xc, 0x46, 0x6, 0x4b, 0x7b, 0x44, 0x69, 0x46, 0x0, 0x90]);
this.file_data_cmd[4] = new Uint8Array([0x20, 0x46, 0x0, 0xf0, 0x7c, 0xfa, 0x4, 0x46, 0x0, 0x20, 0x69, 0x46, 0x0, 0xf0, 0x8a, 0xfa, 0x20, 0x46, 0x1c, 0xbd, 0x27, 0x5, 0x0, 0x0, 0xf, 0xb4, 0x1c, 0xb5, 0x8, 0x4b, 0x6, 0xaa, 0x7b, 0x44, 0x69, 0x46, 0x0, 0x90, 0x5, 0x98, 0x0, 0xf0, 0x69, 0xfa, 0x4, 0x46, 0x0, 0x20, 0x69, 0x46, 0x0, 0xf0, 0x77, 0xfa, 0x20, 0x46, 0x1c, 0xbc, 0x8, 0xbc, 0x4, 0xb0, 0x18, 0x47, 0x1, 0x5, 0x0, 0x0, 0x70, 0xb5, 0xc, 0x46, 0x5, 0x46, 0x1, 0x2a, 0x5, 0xd0, 0x28, 0x78, 0x80, 0x6, 0x0, 0xd5, 0xea, 0x69, 0x0, 0x23, 0x2, 0xe0, 0x1, 0x23, 0x5, 0xe0, 0x5b, 0x1c, 0x93, 0x42, 0x2, 0xd2, 0xe0, 0x5c, 0x0, 0x28, 0xf9, 0xd1, 0xa8, 0x69, 0xe6, 0x18, 0xc0, 0x1a, 0xa8, 0x61, 0x28, 0x6a, 0xc0, 0x18, 0x28, 0x62, 0x28, 0x46, 0x0, 0xf0, 0xb8, 0xf9, 0x4, 0xe0]);
this.file_data_cmd[5] = new Uint8Array([0x6a, 0x68, 0x20, 0x78, 0xa9, 0x68, 0x64, 0x1c, 0x90, 0x47, 0xb4, 0x42, 0xf8, 0xd3, 0x28, 0x46, 0x0, 0xf0, 0xc3, 0xf9, 0x70, 0xbd, 0x0, 0x0, 0xf3, 0xb5, 0x4, 0x46, 0x0, 0x20, 0x81, 0xb0, 0x20, 0x62, 0x20, 0x46, 0xe1, 0x68, 0x88, 0x47, 0x0, 0x28, 0x72, 0xd0, 0x25, 0x28, 0x2, 0xd0, 0x62, 0x68, 0xa1, 0x68, 0xab, 0xe0, 0x59, 0x4f, 0x0, 0x26, 0x7f, 0x44, 0x20, 0x46, 0xe1, 0x68, 0x88, 0x47, 0x20, 0x28, 0x5, 0x46, 0x8, 0xdb, 0x31, 0x2d, 0x6, 0xd2, 0x78, 0x19, 0x20, 0x38, 0x0, 0x78, 0x0, 0x28, 0x1, 0xd0, 0x6, 0x43, 0xf0, 0xe7, 0xb0, 0x7, 0x1, 0xd5, 0x4, 0x20, 0x86, 0x43, 0x0, 0x20, 0xe0, 0x61, 0x7, 0x46, 0xa0, 0x61, 0x2a, 0x2d, 0xa, 0xd0, 0x28, 0x46, 0x4, 0xf0, 0x53, 0xfb, 0x0, 0x28, 0x27, 0xd0, 0xb8, 0x0, 0x0, 0x19, 0x30, 0x3d, 0x0, 0x90]);
this.file_data_cmd[6] = new Uint8Array([0x85, 0x61, 0x19, 0xe0, 0x2, 0x98, 0xba, 0x0, 0x12, 0x19, 0x2, 0xc8, 0x91, 0x61, 0x2, 0x90, 0x20, 0x46, 0xe1, 0x68, 0x88, 0x47, 0x1, 0x2f, 0x5, 0x46, 0x17, 0xd1, 0xe0, 0x69, 0x0, 0x28, 0x1f, 0xda, 0x20, 0x20, 0x86, 0x43, 0x1c, 0xe0, 0x0, 0x98, 0xa, 0x21, 0x80, 0x69, 0x48, 0x43, 0x0, 0x99, 0x40, 0x19, 0x30, 0x38, 0x88, 0x61, 0x20, 0x46, 0xe1, 0x68, 0x88, 0x47, 0x5, 0x46, 0x4, 0xf0, 0x2b, 0xfb, 0x0, 0x28, 0xef, 0xd1, 0x1, 0x2f, 0xa, 0xd0, 0x2e, 0x2d, 0x8, 0xd1, 0x20, 0x46, 0xe1, 0x68, 0x88, 0x47, 0x5, 0x46, 0x20, 0x20, 0x6, 0x43, 0x7f, 0x1c, 0x2, 0x2f, 0xc3, 0xdb, 0xa0, 0x69, 0x0, 0x28, 0x3, 0xda, 0x40, 0x42, 0xa0, 0x61, 0x1, 0x20, 0x6, 0x43, 0xf0, 0x7, 0x1, 0xd0, 0x10, 0x20, 0x86, 0x43, 0x6c, 0x2d, 0xb, 0xd0, 0x68, 0x2d, 0x9, 0xd0]);
this.file_data_cmd[7] = new Uint8Array([0x4c, 0x2d, 0x3c, 0xd0, 0x6a, 0x2d, 0x38, 0xd0, 0x74, 0x2d, 0x38, 0xd0, 0x7a, 0x2d, 0x36, 0xd0, 0x16, 0xe0, 0x40, 0xe0, 0xe1, 0x68, 0x2f, 0x46, 0x20, 0x46, 0x88, 0x47, 0xb8, 0x42, 0x5, 0x46, 0x9, 0xd1, 0x6c, 0x2f, 0x29, 0xd0, 0x1, 0x20, 0x80, 0x2, 0xe1, 0x68, 0x6, 0x43, 0x20, 0x46, 0x88, 0x47, 0x5, 0x46, 0x4, 0xe0, 0x6c, 0x2f, 0x1d, 0xd0, 0xff, 0x20, 0x1, 0x30, 0x6, 0x43, 0x0, 0x2d, 0x28, 0xd0, 0x28, 0x46, 0x41, 0x38, 0x19, 0x28, 0x3, 0xd8, 0x1, 0x20, 0xc0, 0x2, 0x6, 0x43, 0x20, 0x35, 0x20, 0x46, 0x26, 0x60, 0x29, 0x46, 0x2, 0x9a, 0x16, 0x46, 0xff, 0xf7, 0x5d, 0xfe, 0x0, 0x28, 0x10, 0xd0, 0x1, 0x28, 0xb, 0xd0, 0xf6, 0x1d, 0xf0, 0x8, 0xc0, 0x0, 0x8, 0x30, 0x2, 0x90, 0x55, 0xe7, 0x40, 0x20, 0xe1, 0xe7, 0x80, 0x20, 0xd5, 0xe7, 0x0, 0x20]);
this.file_data_cmd[8] = new Uint8Array([0xd3, 0xe7, 0x36, 0x1d, 0x2, 0x96, 0x4c, 0xe7, 0x62, 0x68, 0x28, 0x46, 0xa1, 0x68, 0x90, 0x47, 0x20, 0x6a, 0x40, 0x1c, 0x44, 0xe7, 0x20, 0x6a, 0xfe, 0xbd, 0x0, 0x0, 0xd2, 0xfe, 0x1, 0x0, 0x3, 0x46, 0x70, 0xb5, 0x2, 0x46, 0xb, 0x43, 0x9b, 0x7, 0xf, 0xd1, 0xe, 0x4c, 0xe6, 0x1, 0x0, 0xe0, 0x8, 0xc2, 0x8, 0xc9, 0x1d, 0x1b, 0x9d, 0x43, 0x35, 0x42, 0xf9, 0xd0, 0xd9, 0xb2, 0x11, 0x70, 0x52, 0x1c, 0x0, 0x29, 0xd, 0xd0, 0x1b, 0xa, 0xf8, 0xe7, 0xb, 0x78, 0x49, 0x1c, 0x13, 0x70, 0x52, 0x1c, 0x0, 0x2b, 0x5, 0xd0, 0xb, 0x78, 0x49, 0x1c, 0x13, 0x70, 0x52, 0x1c, 0x0, 0x2b, 0xf3, 0xd1, 0x70, 0xbd, 0x0, 0x0, 0x1, 0x1, 0x1, 0x1, 0x30, 0xb5, 0x44, 0x1c, 0x3, 0xe0, 0x1, 0x78, 0x40, 0x1c, 0x0, 0x29, 0xd, 0xd0, 0x81, 0x7, 0xf9, 0xd1, 0xb, 0x4b]);
this.file_data_cmd[9] = new Uint8Array([0xdd, 0x1, 0x4, 0xc8, 0xd1, 0x1a, 0x91, 0x43, 0x29, 0x40, 0xfa, 0xd0, 0x0, 0x1b, 0xa, 0x6, 0x3, 0xd0, 0xc0, 0x1e, 0x30, 0xbd, 0x0, 0x1b, 0x30, 0xbd, 0xa, 0x4, 0x1, 0xd0, 0x80, 0x1e, 0x30, 0xbd, 0x9, 0x2, 0xfc, 0xd0, 0x40, 0x1e, 0x30, 0xbd, 0x0, 0x0, 0x1, 0x1, 0x1, 0x1, 0x1, 0xe0, 0x4, 0xc0, 0x9, 0x1f, 0x4, 0x29, 0xfb, 0xd2, 0x8b, 0x7, 0x1, 0xd5, 0x2, 0x80, 0x80, 0x1c, 0xc9, 0x7, 0x0, 0xd0, 0x2, 0x70, 0x70, 0x47, 0x0, 0x29, 0xb, 0xd0, 0xc3, 0x7, 0x2, 0xd0, 0x2, 0x70, 0x40, 0x1c, 0x49, 0x1e, 0x2, 0x29, 0x4, 0xd3, 0x83, 0x7, 0x2, 0xd5, 0x2, 0x80, 0x80, 0x1c, 0x89, 0x1e, 0xe3, 0xe7, 0x0, 0x22, 0xee, 0xe7, 0x0, 0x22, 0xdf, 0xe7, 0x2, 0xa, 0x8, 0x70, 0x4a, 0x70, 0x2, 0xc, 0x8a, 0x70, 0x2, 0xe, 0xca, 0x70, 0x70, 0x47]);
this.file_data_cmd[10] = new Uint8Array([0xf0, 0xb5, 0xd, 0x6, 0x4, 0xa, 0x2c, 0x43, 0x10, 0x70, 0x54, 0x70, 0xd, 0x4, 0x4, 0xc, 0x2c, 0x43, 0x94, 0x70, 0xe, 0x2, 0x4, 0xe, 0x34, 0x43, 0xf, 0xa, 0xd4, 0x70, 0xd, 0xc, 0x11, 0x71, 0x57, 0x71, 0xe, 0xe, 0x95, 0x71, 0xd6, 0x71, 0xf0, 0xbd, 0x3, 0x46, 0xca, 0x2, 0x40, 0xd, 0x10, 0xb5, 0x10, 0x43, 0xa, 0x15, 0x4, 0xd0, 0x1, 0x24, 0xe4, 0x7, 0x20, 0x43, 0x0, 0x2a, 0x5, 0xdb, 0xa, 0x4c, 0xa2, 0x1a, 0x4, 0xd4, 0xd0, 0x40, 0xff, 0x2a, 0x0, 0xdd, 0x0, 0x20, 0x10, 0xbd, 0x4a, 0x0, 0x0, 0x2b, 0x1, 0xd0, 0x1, 0x20, 0x0, 0xe0, 0x0, 0x20, 0x10, 0x18, 0x1, 0x22, 0x52, 0x5, 0xd0, 0x42, 0xf2, 0xd8, 0xc8, 0x17, 0xc0, 0x43, 0x10, 0xbd, 0x1e, 0x4, 0x0, 0x0, 0x1, 0x21, 0xc9, 0x5, 0x1, 0x23, 0x41, 0x18, 0x42, 0x0, 0x1b, 0x6]);
this.file_data_cmd[11] = new Uint8Array([0xd3, 0x18, 0x5b, 0xe, 0xa, 0xd0, 0xc1, 0x10, 0x7, 0x22, 0xd2, 0x6, 0x89, 0x18, 0x40, 0x7, 0x52, 0x42, 0xd1, 0x42, 0x1, 0xd5, 0x52, 0x0, 0x89, 0x18, 0x70, 0x47, 0x9, 0x2, 0x8, 0xd5, 0x1, 0x46, 0x0, 0x2a, 0x3, 0xd0, 0xc1, 0xf, 0xc9, 0x7, 0x0, 0x20, 0x70, 0x47, 0x10, 0x46, 0x70, 0x47, 0x42, 0x2, 0x2, 0xd0, 0x0, 0x20, 0x2, 0x49, 0x70, 0x47, 0x7, 0x21, 0x9, 0x5, 0x1, 0x43, 0xf4, 0xe7, 0x0, 0x0, 0xf8, 0x7f, 0x10, 0xb5, 0x0, 0xf0, 0x97, 0xfa, 0x0, 0x1d, 0x10, 0xbd, 0x0, 0xbf, 0x81, 0xbc, 0x1, 0x0, 0x10, 0xb5, 0x0, 0xf0, 0x93, 0xfa, 0x0, 0x68, 0x10, 0xbd, 0x10, 0xb5, 0x4, 0x46, 0x0, 0xf0, 0x8d, 0xfa, 0x4, 0x60, 0x10, 0xbd, 0x70, 0xb5, 0x4, 0x46, 0x85, 0x69, 0x0, 0x68, 0xc1, 0x6, 0x1, 0xd5, 0x30, 0x26, 0x0, 0xe0, 0x20, 0x26]);
this.file_data_cmd[12] = new Uint8Array([0xc0, 0x7, 0x7, 0xd0, 0x70, 0xbd, 0x62, 0x68, 0x30, 0x46, 0xa1, 0x68, 0x90, 0x47, 0x20, 0x6a, 0x40, 0x1c, 0x20, 0x62, 0x6d, 0x1e, 0xf6, 0xd5, 0x70, 0xbd, 0x70, 0xb5, 0x4, 0x46, 0x85, 0x69, 0x0, 0x78, 0xc0, 0x7, 0x7, 0xd1, 0x70, 0xbd, 0x62, 0x68, 0xa1, 0x68, 0x20, 0x20, 0x90, 0x47, 0x20, 0x6a, 0x40, 0x1c, 0x20, 0x62, 0x6d, 0x1e, 0xf6, 0xd5, 0x70, 0xbd, 0x9, 0x68, 0x4a, 0x5, 0x1, 0xd5, 0x40, 0xb2, 0x70, 0x47, 0xc9, 0x5, 0xfc, 0xd5, 0x0, 0xb2, 0x70, 0x47, 0x9, 0x68, 0x4a, 0x5, 0x1, 0xd5, 0xc0, 0xb2, 0x70, 0x47, 0xc9, 0x5, 0xfc, 0xd5, 0x80, 0xb2, 0x70, 0x47, 0xf7, 0xb5, 0x0, 0x25, 0x75, 0x29, 0x10, 0x68, 0x0, 0x99, 0x14, 0xa6, 0x11, 0xd0, 0xff, 0xf7, 0xe5, 0xff, 0x0, 0x28, 0x2, 0xda, 0x40, 0x42, 0x11, 0xa6, 0x8, 0xe0, 0x0, 0x99, 0x9, 0x68]);
this.file_data_cmd[13] = new Uint8Array([0x8a, 0x7, 0x1, 0xd5, 0xf, 0xa6, 0x2, 0xe0, 0x49, 0x7, 0x4, 0xd5, 0xe, 0xa6, 0x1, 0x25, 0x1, 0xe0, 0xff, 0xf7, 0xdc, 0xff, 0x0, 0x9f, 0x0, 0x24, 0x24, 0x37, 0x4, 0xe0, 0x0, 0xf0, 0x7a, 0xfe, 0x30, 0x31, 0x39, 0x55, 0x64, 0x1c, 0x0, 0x28, 0xf8, 0xd1, 0x2b, 0x46, 0x32, 0x46, 0x21, 0x46, 0x0, 0x98, 0x0, 0xf0, 0x67, 0xfa, 0xfe, 0xbd, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x2d, 0x0, 0x0, 0x0, 0x2b, 0x0, 0x0, 0x0, 0x20, 0x0, 0x0, 0x0, 0x11, 0x68, 0x2, 0x68, 0x0, 0x6a, 0x53, 0x5, 0x1, 0xd5, 0x8, 0x70, 0x9, 0xe0, 0xd3, 0x5, 0x1, 0xd5, 0x8, 0x80, 0x5, 0xe0, 0x13, 0x6, 0x2, 0xd5, 0xc2, 0x17, 0x5, 0xc1, 0x0, 0xe0, 0x8, 0x60, 0x1, 0x20, 0x70, 0x47, 0x0, 0x0, 0x1, 0x69, 0x4a, 0x1c, 0x2, 0x61, 0x8, 0x78, 0x70, 0x47, 0x0, 0xb5]);
this.file_data_cmd[14] = new Uint8Array([0x8f, 0xb0, 0x2, 0x91, 0x0, 0x21, 0x5, 0x91, 0x5, 0x49, 0x1, 0x93, 0x79, 0x44, 0x3, 0x91, 0x11, 0x46, 0x4, 0x90, 0x68, 0x46, 0xff, 0xf7, 0xbf, 0xfd, 0xf, 0xb0, 0x0, 0xbd, 0x0, 0x0, 0xe5, 0xff, 0xff, 0xff, 0xa, 0x68, 0x10, 0x70, 0x52, 0x1c, 0xa, 0x60, 0x70, 0x47, 0x10, 0xb5, 0x43, 0x69, 0x0, 0x2b, 0x2, 0xd0, 0xc0, 0x46, 0xc0, 0x46, 0x1, 0xe0, 0xff, 0xf7, 0x82, 0xfd, 0x1, 0x20, 0x10, 0xbd, 0x12, 0x78, 0x1, 0x46, 0x24, 0x31, 0xa, 0x70, 0x0, 0x22, 0x4a, 0x70, 0x1, 0x22, 0xec, 0xe7, 0x11, 0x68, 0x0, 0x22, 0xd2, 0x43, 0xe8, 0xe7, 0xf7, 0xb5, 0x4, 0x46, 0x15, 0x46, 0x86, 0xb0, 0x2b, 0x48, 0x78, 0x44, 0x0, 0x27, 0x3, 0xc8, 0x3e, 0x46, 0x0, 0x90, 0x1, 0x91, 0x11, 0xe0, 0x7, 0x98, 0x6a, 0x46, 0x71, 0x0, 0x41, 0x5a, 0x2, 0xa8, 0x0, 0xf0]);
this.file_data_cmd[15] = new Uint8Array([0xea, 0xfd, 0x41, 0x1c, 0x7, 0xd0, 0x21, 0x78, 0x89, 0x6, 0x3, 0xd5, 0xe2, 0x69, 0x39, 0x18, 0x91, 0x42, 0xe, 0xd8, 0x3f, 0x18, 0x76, 0x1c, 0x20, 0x78, 0x80, 0x6, 0x2, 0xd5, 0xe0, 0x69, 0xb8, 0x42, 0x6, 0xdd, 0xae, 0x42, 0xe5, 0xdb, 0x7, 0x98, 0x71, 0x0, 0x40, 0x5a, 0x0, 0x28, 0xe0, 0xd1, 0xa0, 0x69, 0xc0, 0x1b, 0xa0, 0x61, 0x20, 0x46, 0xff, 0xf7, 0x18, 0xff, 0x15, 0x48, 0x78, 0x44, 0x5a, 0x38, 0x3, 0xc8, 0x0, 0x90, 0x0, 0x20, 0x1, 0x91, 0x16, 0xe0, 0x41, 0x0, 0x6a, 0x46, 0x7, 0x98, 0x41, 0x5a, 0x2, 0xa8, 0x0, 0xf0, 0xbd, 0xfd, 0x5, 0x90, 0x40, 0x1c, 0xa, 0xd0, 0x0, 0x25, 0x5, 0xe0, 0x62, 0x68, 0x2, 0xa8, 0xa1, 0x68, 0x40, 0x5d, 0x90, 0x47, 0x6d, 0x1c, 0x5, 0x98, 0x85, 0x42, 0xf6, 0xd3, 0x4, 0x98, 0x40, 0x1c, 0xb0, 0x42, 0x4, 0x90]);
this.file_data_cmd[16] = new Uint8Array([0xe5, 0xdb, 0x20, 0x6a, 0xc0, 0x19, 0x20, 0x62, 0x20, 0x46, 0xff, 0xf7, 0x6, 0xff, 0x9, 0xb0, 0xf0, 0xbd, 0x0, 0x0, 0x8e, 0xfa, 0x1, 0x0, 0xf7, 0xb5, 0xd2, 0x1d, 0x0, 0x25, 0xd2, 0x8, 0x15, 0xa6, 0xd2, 0x0, 0xf5, 0x29, 0x5, 0xca, 0x11, 0xd0, 0x0, 0x2a, 0x5, 0xda, 0x0, 0x21, 0x40, 0x42, 0x91, 0x41, 0x11, 0xa6, 0xa, 0x46, 0x8, 0xe0, 0x0, 0x99, 0x9, 0x68, 0x8b, 0x7, 0x1, 0xd5, 0xf, 0xa6, 0x2, 0xe0, 0x49, 0x7, 0x1, 0xd5, 0xe, 0xa6, 0x1, 0x25, 0x11, 0x46, 0x0, 0x9f, 0x0, 0x24, 0x24, 0x37, 0x4, 0xe0, 0x0, 0xf0, 0x58, 0xf9, 0x30, 0x32, 0x3a, 0x55, 0x64, 0x1c, 0x2, 0x46, 0xa, 0x43, 0xf7, 0xd1, 0x2b, 0x46, 0x32, 0x46, 0x21, 0x46, 0x0, 0x98, 0x0, 0xf0, 0x89, 0xf9, 0xfe, 0xbd, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x2d, 0x0, 0x0, 0x0]);
this.file_data_cmd[17] = new Uint8Array([0x2b, 0x0, 0x0, 0x0, 0x20, 0x0, 0x0, 0x0, 0x70, 0xb5, 0x4, 0x46, 0x0, 0x21, 0x24, 0x34, 0x8, 0xe0, 0x55, 0x7, 0xd2, 0x8, 0x6d, 0xf, 0x30, 0x35, 0x65, 0x54, 0x5d, 0x7, 0x2a, 0x43, 0xdb, 0x8, 0x49, 0x1c, 0x15, 0x46, 0x1d, 0x43, 0xf3, 0xd1, 0x4, 0x68, 0x0, 0x23, 0x10, 0xa2, 0x25, 0x7, 0x8, 0xd5, 0xa4, 0x6, 0x1, 0xd4, 0x0, 0x29, 0x4, 0xd0, 0xc4, 0x69, 0x1, 0x23, 0xc, 0xa2, 0x64, 0x1e, 0xc4, 0x61, 0x0, 0xf0, 0x5e, 0xf9, 0x70, 0xbd, 0x10, 0xb5, 0x4, 0x46, 0x21, 0x46, 0x10, 0x68, 0xff, 0xf7, 0xbb, 0xfe, 0x0, 0x23, 0x2, 0x46, 0x20, 0x46, 0xff, 0xf7, 0xd3, 0xff, 0x10, 0xbd, 0xd2, 0x1d, 0xd1, 0x8, 0xc9, 0x0, 0xc, 0xc9, 0xcc, 0xe7, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x30, 0x0, 0x0, 0x0, 0xf8, 0xb5, 0xf, 0x46, 0x1, 0x88, 0x9, 0x5]);
this.file_data_cmd[18] = new Uint8Array([0x2, 0xd5, 0x22, 0x4c, 0x7c, 0x44, 0x2, 0xe0, 0x20, 0x4c, 0x7c, 0x44, 0xe, 0x34, 0x5, 0x46, 0x0, 0x21, 0x24, 0x35, 0x8, 0xe0, 0x16, 0x7, 0x12, 0x9, 0x36, 0xf, 0xa6, 0x5d, 0x6e, 0x54, 0x1e, 0x7, 0x32, 0x43, 0x1b, 0x9, 0x49, 0x1c, 0x16, 0x46, 0x1e, 0x43, 0xf3, 0xd1, 0x22, 0x46, 0x4, 0x78, 0x0, 0x23, 0x24, 0x7, 0x5, 0xd5, 0x70, 0x2f, 0x6, 0xd0, 0x0, 0x29, 0x1, 0xd0, 0x2, 0x23, 0x11, 0x32, 0x0, 0xf0, 0x1f, 0xf9, 0xf8, 0xbd, 0x1, 0x23, 0x10, 0x32, 0xf9, 0xe7, 0x70, 0xb5, 0x4, 0x46, 0xd, 0x46, 0x21, 0x46, 0x10, 0x68, 0xff, 0xf7, 0x78, 0xfe, 0x0, 0x23, 0x2, 0x46, 0x29, 0x46, 0x20, 0x46, 0xff, 0xf7, 0xc7, 0xff, 0x70, 0xbd, 0xd2, 0x1d, 0xd3, 0x8, 0xdb, 0x0, 0xc, 0xcb, 0xc0, 0xe7, 0x30, 0xb4, 0x3, 0x68, 0x20, 0x24, 0x12, 0x68, 0x23, 0x43]);
this.file_data_cmd[19] = new Uint8Array([0x3, 0x60, 0x8, 0x23, 0xc3, 0x61, 0x30, 0xbc, 0x0, 0x23, 0xb5, 0xe7, 0xf8, 0xf8, 0x1, 0x0, 0x70, 0xb5, 0x5, 0x46, 0x48, 0x0, 0x44, 0xd, 0x12, 0x4b, 0x0, 0x20, 0x0, 0x2c, 0xa, 0xd0, 0x63, 0x40, 0x8, 0xd0, 0x9a, 0x42, 0x6, 0xda, 0x66, 0x42, 0xb2, 0x42, 0x3, 0xdd, 0x12, 0x5, 0x40, 0x19, 0x51, 0x41, 0x70, 0xbd, 0x0, 0x2c, 0x8, 0xd0, 0x0, 0x2b, 0x9, 0xd0, 0xc9, 0xf, 0xc9, 0x7, 0x0, 0x2a, 0xf6, 0xdb, 0x8, 0x4a, 0x11, 0x43, 0x70, 0xbd, 0xc9, 0xf, 0xc9, 0x7, 0x70, 0xbd, 0x28, 0x46, 0xa, 0x3, 0x10, 0x43, 0x2, 0xd0, 0x0, 0x20, 0x3, 0x49, 0x70, 0xbd, 0x28, 0x46, 0x70, 0xbd, 0xff, 0x7, 0x0, 0x0, 0x0, 0x0, 0xf0, 0x7f, 0x0, 0x0, 0xf8, 0x7f, 0xf0, 0xb5, 0x3d, 0x4b, 0x2, 0x46, 0xc, 0x46, 0x1c, 0x40, 0x0, 0x20, 0x0, 0x2c, 0x63, 0xd0]);
this.file_data_cmd[20] = new Uint8Array([0x3a, 0x4d, 0x8b, 0x43, 0x66, 0xd0, 0x0, 0x29, 0x6b, 0xdb, 0xb, 0xd, 0x1d, 0x5, 0xa9, 0x43, 0x1, 0x25, 0x2d, 0x5, 0x29, 0x43, 0x1, 0x24, 0xfd, 0x33, 0xe3, 0x40, 0x1, 0xd3, 0x92, 0x18, 0x49, 0x41, 0xff, 0x33, 0x81, 0x33, 0x9c, 0x46, 0x8b, 0x2, 0x94, 0xd, 0x1, 0x21, 0x23, 0x43, 0x89, 0x7, 0x4c, 0x42, 0x92, 0x2, 0x0, 0x27, 0x1b, 0x19, 0x8c, 0x10, 0x5d, 0x1a, 0x4, 0xd4, 0x2d, 0x1b, 0x2, 0xd4, 0x2b, 0x46, 0x65, 0x0, 0x49, 0x19, 0x92, 0x18, 0x5b, 0x41, 0x64, 0x8, 0xf4, 0xd1, 0x5c, 0x1a, 0x8, 0xd4, 0x1, 0x25, 0xed, 0x7, 0xee, 0x17, 0x55, 0x19, 0x74, 0x41, 0x2, 0xd4, 0x2a, 0x46, 0x23, 0x46, 0x49, 0x1c, 0x94, 0x18, 0x5b, 0x41, 0x1, 0x22, 0x92, 0x7, 0x1d, 0x46, 0xe6, 0x1b, 0x8d, 0x41, 0x6, 0xd4, 0xb6, 0x1a, 0x85, 0x41, 0x3, 0xd4, 0x2b, 0x46]);
this.file_data_cmd[21] = new Uint8Array([0x55, 0x0, 0x34, 0x46, 0x7f, 0x19, 0x24, 0x19, 0x5b, 0x41, 0x52, 0x8, 0x80, 0x2a, 0xef, 0xd1, 0x23, 0x43, 0x0, 0xd0, 0x2, 0x23, 0x38, 0x46, 0xa, 0x22, 0xd0, 0x40, 0x1, 0xd3, 0x1, 0x22, 0x13, 0x43, 0x8a, 0x5, 0x10, 0x43, 0x62, 0x46, 0x89, 0xa, 0x12, 0x5, 0x89, 0x18, 0x0, 0x2b, 0x9, 0xd0, 0x1, 0x22, 0xd3, 0x40, 0x2, 0xd3, 0x0, 0x22, 0x40, 0x1c, 0x51, 0x41, 0x0, 0x2b, 0x1, 0xd1, 0x40, 0x8, 0x40, 0x0, 0xf0, 0xbd, 0xb, 0x3, 0x13, 0x43, 0x7, 0xd0, 0xc9, 0xf, 0xc9, 0x7, 0xf0, 0xbd, 0x8, 0x3, 0x10, 0x43, 0x3, 0xd1, 0x0, 0x29, 0x1, 0xdb, 0x10, 0x46, 0xf0, 0xbd, 0x0, 0x20, 0x29, 0x46, 0xf0, 0xbd, 0x0, 0x0, 0xf0, 0x7f, 0x0, 0x0, 0xf8, 0x7f, 0x1, 0x49, 0x18, 0x20, 0xab, 0xbe, 0xfe, 0xe7, 0x26, 0x0, 0x2, 0x0, 0x0, 0x48, 0x70, 0x47]);
this.file_data_cmd[22] = new Uint8Array([0x90, 0x2b, 0x0, 0x20, 0x0, 0x48, 0x70, 0x47, 0x70, 0x2b, 0x0, 0x20, 0xb, 0x46, 0x70, 0xb5, 0x2, 0x46, 0x89, 0x7, 0x80, 0x8, 0x8, 0x43, 0x19, 0x46, 0x9d, 0x8, 0x14, 0x1a, 0xa9, 0x41, 0x25, 0x9, 0x8, 0x7, 0x5, 0x43, 0x8, 0x9, 0x2c, 0x19, 0x48, 0x41, 0x25, 0xa, 0x1, 0x6, 0xd, 0x43, 0x1, 0xa, 0x2c, 0x19, 0x41, 0x41, 0x20, 0xc, 0xd, 0x4, 0x28, 0x43, 0xd, 0xc, 0x0, 0x19, 0x4d, 0x41, 0x0, 0x21, 0x40, 0x19, 0x4d, 0x41, 0xc0, 0x8, 0x69, 0x7, 0x8, 0x43, 0xe9, 0x8, 0x84, 0xf, 0x8d, 0x0, 0x25, 0x43, 0x84, 0x0, 0x24, 0x18, 0x4d, 0x41, 0x24, 0x19, 0x6d, 0x41, 0x12, 0x1b, 0xab, 0x41, 0x7, 0xe0, 0x9, 0x25, 0xed, 0x43, 0x2c, 0x11, 0x52, 0x19, 0x63, 0x41, 0x0, 0x24, 0x40, 0x1c, 0x61, 0x41, 0x1c, 0x46, 0xa, 0x25, 0x0, 0x26, 0x55, 0x1b]);
this.file_data_cmd[23] = new Uint8Array([0xb4, 0x41, 0xf1, 0xd2, 0x70, 0xbd, 0xff, 0xb5, 0x4, 0x46, 0xd, 0x46, 0x81, 0xb0, 0x24, 0x30, 0x0, 0x90, 0x21, 0x68, 0x88, 0x6, 0x4, 0xd5, 0x10, 0x22, 0xe0, 0x69, 0x91, 0x43, 0x21, 0x60, 0x0, 0xe0, 0x1, 0x20, 0xa8, 0x42, 0x1, 0xdd, 0x47, 0x1b, 0x0, 0xe0, 0x0, 0x27, 0x4, 0x98, 0xa1, 0x69, 0x7a, 0x19, 0x10, 0x18, 0x8, 0x1a, 0xa0, 0x61, 0x20, 0x78, 0xc0, 0x6, 0x2, 0xd4, 0x20, 0x46, 0xff, 0xf7, 0x14, 0xfd, 0x0, 0x26, 0x8, 0xe0, 0x3, 0x98, 0x62, 0x68, 0xa1, 0x68, 0x80, 0x5d, 0x90, 0x47, 0x20, 0x6a, 0x40, 0x1c, 0x76, 0x1c, 0x20, 0x62, 0x4, 0x98, 0x86, 0x42, 0xf3, 0xdb, 0x20, 0x78, 0xc0, 0x6, 0xa, 0xd5, 0x20, 0x46, 0xff, 0xf7, 0x0, 0xfd, 0x6, 0xe0, 0x62, 0x68, 0xa1, 0x68, 0x30, 0x20, 0x90, 0x47, 0x20, 0x6a, 0x40, 0x1c, 0x20, 0x62, 0x38, 0x46]);
this.file_data_cmd[24] = new Uint8Array([0x7f, 0x1e, 0x0, 0x28, 0xf4, 0xdc, 0x7, 0xe0, 0x0, 0x98, 0x62, 0x68, 0xa1, 0x68, 0x40, 0x5d, 0x90, 0x47, 0x20, 0x6a, 0x40, 0x1c, 0x20, 0x62, 0x28, 0x46, 0x6d, 0x1e, 0x0, 0x28, 0xf3, 0xdc, 0x20, 0x46, 0xff, 0xf7, 0xfa, 0xfc, 0x20, 0x78, 0x0, 0x6, 0x2, 0xd5, 0x2, 0x20, 0x5, 0xb0, 0xf0, 0xbd, 0x1, 0x20, 0xfb, 0xe7, 0x0, 0x0, 0x70, 0x47, 0xff, 0xb5, 0xc, 0x46, 0x1e, 0x46, 0x8f, 0xb0, 0x3, 0xca, 0x8, 0x90, 0x9, 0x91, 0x4f, 0x0, 0x7d, 0xd, 0x0, 0xd1, 0x6d, 0x1e, 0x0, 0x21, 0x8, 0x46, 0x0, 0x20, 0xc0, 0x46, 0x3, 0x21, 0x9, 0x9a, 0x89, 0x5, 0x8, 0x40, 0x0, 0x2a, 0x3, 0xda, 0x82, 0x0, 0x80, 0x18, 0x40, 0x8, 0x8, 0x40, 0x80, 0xd, 0x1, 0x28, 0xa, 0x90, 0x2, 0xdd, 0x0, 0x20, 0xc0, 0x43, 0xa, 0x90, 0x8, 0x98, 0x7, 0x43, 0xd, 0xd0]);
this.file_data_cmd[25] = new Uint8Array([0xf0, 0x48, 0xf1, 0x49, 0x28, 0x18, 0x48, 0x43, 0x7, 0x14, 0x18, 0x98, 0x0, 0x28, 0x1d, 0xd0, 0x75, 0x42, 0x29, 0x1e, 0x1d, 0xdd, 0xa, 0x98, 0x42, 0x42, 0x1b, 0xe0, 0x18, 0x98, 0x1, 0x28, 0x2, 0xd0, 0x0, 0x20, 0x30, 0x21, 0x4, 0xe0, 0x0, 0x20, 0xf2, 0x43, 0x5, 0xe0, 0x21, 0x54, 0x40, 0x1c, 0xb0, 0x42, 0xfb, 0xdb, 0x30, 0x46, 0x0, 0x22, 0x18, 0x9b, 0x0, 0x21, 0x21, 0x54, 0xf, 0x99, 0x8b, 0x60, 0xa, 0x60, 0x48, 0x60, 0x13, 0xb0, 0xf0, 0xbd, 0xbd, 0x1b, 0x6d, 0x1c, 0xdf, 0xe7, 0xa, 0x9a, 0x0, 0x29, 0x0, 0xda, 0x69, 0x42, 0xb, 0xa8, 0x0, 0xf0, 0xb4, 0xfb, 0xb, 0xab, 0x7, 0xcb, 0x3, 0xab, 0x7, 0xc3, 0x8, 0x99, 0x9, 0x98, 0x0, 0xf0, 0x18, 0xfc, 0x6b, 0x46, 0x7, 0xc3, 0x1, 0x46, 0xd5, 0x48, 0x9, 0x18, 0x0, 0x2d, 0x0, 0x91, 0xb, 0xdd]);
this.file_data_cmd[26] = new Uint8Array([0xd2, 0x49, 0x3, 0x98, 0xa, 0x9a, 0x49, 0x42, 0x40, 0x18, 0x0, 0x23, 0x3, 0xa9, 0x3, 0x90, 0x68, 0x46, 0x0, 0xf0, 0x75, 0xfe, 0x8, 0xe0, 0x3, 0x99, 0xa, 0x9a, 0x0, 0x23, 0x8, 0x18, 0x3, 0xa9, 0x3, 0x90, 0x68, 0x46, 0x0, 0xf0, 0x15, 0xfe, 0x6b, 0x46, 0x7, 0xc3, 0x0, 0x4, 0x0, 0xc, 0x3, 0xd0, 0x0, 0x20, 0xc0, 0x43, 0x41, 0x8, 0x0, 0xe0, 0x10, 0x46, 0x18, 0x9a, 0x0, 0x2a, 0x3, 0xd0, 0x0, 0x22, 0x0, 0x92, 0x15, 0x46, 0x1e, 0xe0, 0x75, 0x1e, 0x5, 0xd4, 0xff, 0xf7, 0xdc, 0xfe, 0x30, 0x32, 0x62, 0x55, 0x6d, 0x1e, 0xf9, 0xd5, 0x1, 0x22, 0x8, 0x43, 0x7, 0x96, 0x2, 0xd0, 0x0, 0x22, 0x7f, 0x1c, 0x4, 0xe0, 0x20, 0x78, 0x30, 0x28, 0x1, 0xd1, 0x0, 0x22, 0x7f, 0x1e, 0x0, 0x2a, 0x6, 0x97, 0x87, 0xd0, 0x1e, 0xe0, 0x11, 0x2d, 0x7, 0xda]);
this.file_data_cmd[27] = new Uint8Array([0xff, 0xf7, 0xc4, 0xfe, 0x30, 0x32, 0x62, 0x55, 0x6d, 0x1c, 0x2, 0x46, 0xa, 0x43, 0xf5, 0xd1, 0x8, 0x43, 0x3, 0xd0, 0x0, 0x98, 0x0, 0x28, 0x19, 0xd0, 0xe, 0xe0, 0x0, 0x21, 0x68, 0x1e, 0x5, 0xe0, 0x23, 0x5c, 0x62, 0x5c, 0x63, 0x54, 0x22, 0x54, 0x40, 0x1e, 0x49, 0x1c, 0x81, 0x42, 0xf7, 0xdb, 0xa8, 0x1b, 0x40, 0x1e, 0x7, 0x95, 0x6, 0x90, 0x7, 0x9a, 0x18, 0x99, 0x0, 0x20, 0xa0, 0x54, 0xf, 0x98, 0x7, 0x9b, 0x6, 0x9a, 0x81, 0x60, 0xc, 0xc0, 0x7c, 0xe7, 0x11, 0x26, 0x0, 0x20, 0x18, 0x90, 0x59, 0xe7, 0xd2, 0x1d, 0xf0, 0xb5, 0xd, 0x46, 0x4, 0x46, 0xd1, 0x8, 0x93, 0xb0, 0xc9, 0x0, 0x3, 0xc9, 0xc, 0x90, 0xd, 0x91, 0x3, 0xf0, 0x21, 0xfb, 0x2, 0x46, 0xd, 0x98, 0xc0, 0xf, 0x1, 0xd0, 0x2d, 0x20, 0x7, 0xe0, 0x20, 0x68, 0x81, 0x7, 0x1, 0xd5]);
this.file_data_cmd[28] = new Uint8Array([0x2b, 0x20, 0x2, 0xe0, 0x40, 0x7, 0xc0, 0xf, 0x40, 0x1, 0x3, 0x2a, 0xf, 0x90, 0x1, 0xd0, 0x7, 0x2a, 0x5, 0xdb, 0x3, 0x46, 0x29, 0x46, 0x20, 0x46, 0x0, 0xf0, 0xd1, 0xfa, 0xe, 0xe1, 0x20, 0x78, 0x80, 0x6, 0x1, 0xd5, 0xe7, 0x69, 0x0, 0xe0, 0x6, 0x27, 0x28, 0x46, 0x65, 0x2d, 0x4, 0xd0, 0x66, 0x28, 0x14, 0xd0, 0x67, 0x2d, 0x69, 0xd1, 0x2d, 0xe0, 0x0, 0x20, 0x11, 0x2f, 0x0, 0x90, 0x1, 0xdb, 0x11, 0x23, 0x0, 0xe0, 0x7b, 0x1c, 0xc, 0xaa, 0x3, 0xa9, 0x10, 0xa8, 0xff, 0xf7, 0xf3, 0xfe, 0x11, 0x99, 0x0, 0x26, 0x10, 0x98, 0x7d, 0x1c, 0xe, 0x91, 0x42, 0xe0, 0x1, 0x20, 0x3b, 0x46, 0xc, 0xaa, 0xc0, 0x7, 0xb, 0x90, 0x1, 0x20, 0x0, 0x90, 0x3, 0xa9, 0x10, 0xa8, 0xff, 0xf7, 0xe2, 0xfe, 0x11, 0x9d, 0x12, 0x98, 0x10, 0x99, 0x0, 0x26, 0x0, 0x28]);
this.file_data_cmd[29] = new Uint8Array([0xe, 0x95, 0x1, 0xd1, 0x78, 0x1c, 0xd, 0x18, 0x78, 0x1b, 0x2, 0xd4, 0x46, 0x42, 0x7d, 0x1c, 0x76, 0x1e, 0xe8, 0x1b, 0x0, 0x90, 0x3a, 0xe0, 0x1, 0x2f, 0x0, 0xda, 0x1, 0x27, 0x0, 0x20, 0x11, 0x2f, 0x0, 0x90, 0x1, 0xdd, 0x11, 0x23, 0x0, 0xe0, 0x3b, 0x46, 0xc, 0xaa, 0x3, 0xa9, 0x10, 0xa8, 0xff, 0xf7, 0xc2, 0xfe, 0x11, 0x99, 0x3d, 0x46, 0x10, 0x98, 0x0, 0x26, 0xe, 0x91, 0x21, 0x78, 0x9, 0x7, 0xb, 0xd4, 0xe, 0x99, 0xa9, 0x42, 0x0, 0xda, 0xd, 0x46, 0x3, 0xa9, 0x1, 0x2d, 0x4, 0xdd, 0x4a, 0x19, 0x20, 0x3a, 0xd2, 0x7f, 0x30, 0x2a, 0x6, 0xd0, 0xb8, 0x42, 0x1, 0xda, 0x1, 0x1d, 0x4, 0xda, 0x1, 0x21, 0x0, 0x91, 0xf, 0xe0, 0x6d, 0x1e, 0xef, 0xe7, 0x0, 0x28, 0x2, 0xdc, 0x86, 0x19, 0x2d, 0x1a, 0x3, 0xe0, 0x41, 0x1c, 0xa9, 0x42, 0x0, 0xdd]);
this.file_data_cmd[30] = new Uint8Array([0xd, 0x46, 0x80, 0x1b, 0x40, 0x1c, 0x0, 0x90, 0x1, 0x20, 0xc0, 0x7, 0xb, 0x90, 0x20, 0x78, 0x0, 0x7, 0x5, 0xd4, 0x0, 0x98, 0xa8, 0x42, 0x2, 0xdb, 0x0, 0x20, 0xc0, 0x43, 0x0, 0x90, 0x69, 0x46, 0x0, 0x20, 0xc8, 0x72, 0xb, 0x98, 0x1, 0x21, 0x2, 0xaf, 0x3, 0x37, 0xc9, 0x7, 0x88, 0x42, 0x25, 0xd0, 0x2, 0x20, 0x10, 0x90, 0x2b, 0x20, 0x11, 0x90, 0xb, 0x98, 0x0, 0x28, 0xb, 0xda, 0x40, 0x42, 0xb, 0x90, 0x2d, 0x20, 0x11, 0x90, 0x6, 0xe0, 0xb, 0x98, 0x0, 0xf0, 0x22, 0xfa, 0x30, 0x31, 0x7f, 0x1e, 0xb, 0x90, 0x39, 0x70, 0x10, 0x99, 0x48, 0x1e, 0x0, 0x29, 0x10, 0x90, 0xf3, 0xdc, 0xb, 0x98, 0x0, 0x28, 0xf0, 0xd1, 0x11, 0x98, 0x7f, 0x1e, 0x38, 0x70, 0x20, 0x88, 0x0, 0x5, 0x1, 0xd5, 0x45, 0x20, 0x0, 0xe0, 0x65, 0x20, 0x7f, 0x1e, 0x38, 0x70]);
this.file_data_cmd[31] = new Uint8Array([0x1, 0xa8, 0xc0, 0x1b, 0xc0, 0x1d, 0xb, 0x90, 0xf, 0x98, 0x0, 0x28, 0x0, 0xd0, 0x1, 0x20, 0x41, 0x19, 0x0, 0x98, 0xc0, 0x17, 0x9, 0x18, 0xb, 0x98, 0x8, 0x18, 0xa1, 0x69, 0x8, 0x1a, 0x40, 0x1e, 0xa0, 0x61, 0x20, 0x78, 0xc0, 0x6, 0x2, 0xd4, 0x20, 0x46, 0xff, 0xf7, 0x1f, 0xfb, 0xf, 0x98, 0x0, 0x28, 0x5, 0xd0, 0x62, 0x68, 0xa1, 0x68, 0x90, 0x47, 0x20, 0x6a, 0x40, 0x1c, 0x20, 0x62, 0x20, 0x78, 0xc0, 0x6, 0x25, 0xd5, 0x20, 0x46, 0xff, 0xf7, 0x10, 0xfb, 0x21, 0xe0, 0x0, 0x2e, 0x7, 0xdb, 0xe, 0x98, 0xb0, 0x42, 0x4, 0xdd, 0x3, 0xa8, 0x62, 0x68, 0x80, 0x5d, 0xa1, 0x68, 0x2, 0xe0, 0x62, 0x68, 0xa1, 0x68, 0x30, 0x20, 0x90, 0x47, 0x20, 0x6a, 0x76, 0x1c, 0x40, 0x1c, 0x20, 0x62, 0x0, 0x98, 0x40, 0x1e, 0x0, 0x28, 0x0, 0x90, 0xa, 0xd1, 0xff, 0xf7]);
*/
